import { BuilderConfig } from '../../types/Builder';
import BusinessHubTrustedBrand, { BusinessHubTrustedBrandProps } from './business-hub-trusted-brand';

export const BusinessHubTrustedBrandConfig = {
    name: 'Business Hub Trusted Brand',
    inputs: [
        {
            name: 'title',
            type: 'string',
        },
        {
            name: 'industryCommon',
            type: 'reference',
            model: 'business-industries',
        },
        {
            name: 'textColor',
            type: 'color',
        },
        {
            name: 'background',
            type: 'color',
        },
        {
            name: 'roundedBottom',
            type: 'boolean',
        },
        {
            name: 'isCarousel',
            type: 'boolean',
        },
        {
            name: 'trustedBrands',
            type: 'list',
            helperText: 'Override trusted brands in the common field',
            subFields: [
                {
                    name: 'logo',
                    type: 'file',
                },
                {
                    name: 'name',
                    type: 'string',
                },
                {
                    name: 'ratio',
                    type: 'number',
                    helperText: 'image height / image width',
                },
                {
                    name: 'maxWidth',
                    type: 'number',
                },
                {
                    name: 'maxHeight',
                    type: 'number',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<BusinessHubTrustedBrandProps> = {
    component: BusinessHubTrustedBrand,
    config: BusinessHubTrustedBrandConfig,
};

export default builderConfig;
